export const environment = {
    production: false,
    backAPI: 'https://sociochaux-back-staging-f678d57bcbbd.herokuapp.com',
    hmacSecretKey: 'a1b2c3d4e5f6a7b8c9d0e1f2a3b4c5d6e7f8a9b0c1d2e3f4a5b6c7d8e9f0a1b2'
};
